import React, { FC } from 'react';
import TelescopeIcon from '../../images/telescope.svg'
import { Link } from "react-router-dom";
import { ButtonTypes } from "../../models/ButtonTypes";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import { useSelector } from 'react-redux';
import { RouterRootState } from 'connected-react-router';
import Restricted from '../../contexts/PermissionProvider/RestrictedWrapper';

interface Props {
    rowPath?: string,
    showAddNewButton?: boolean,
    onAddNew?: () => void,
    message?: string
}
const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

const EmptyTableState: FC<Props> = ({ rowPath, showAddNewButton, onAddNew, message }) => {
    const { translate } = useLocale();
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname));

    return <div className=" flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
            <div>
                <img
                    className="mx-auto w-auto"
                    src={TelescopeIcon}
                    alt="telescope" />
                <h2 className="mt-6 text-center text-xl font-extrabold text-gray-700">{message ?? translate.byKey(TranslationKeys.noRecordsfound)}</h2>
                {showAddNewButton && (onAddNew || rowPath) ? <div className="mt-4 text-center">
                    <Restricted to={`add.${routeName}.element`}>
                        {onAddNew ?
                            <button onClick={onAddNew} className={ButtonTypes.BlueButton}>
                                {translate.byKey(TranslationKeys.addNew)}
                            </button> :
                            rowPath ? <Link to={rowPath} className={ButtonTypes.BlueButton}>
                                {translate.byKey(TranslationKeys.addNew)}
                            </Link> :
                                null}
                    </Restricted>
                </div> : null}
            </div>

        </div>
    </div>
};

export default EmptyTableState;
